import coverApi from '@/services/CoverApi'
import dayjs from 'dayjs'
import store from '@/store/store.js'

export default {
  namespaced: true,
  state: {
    covers: [],
    paginationData: {
      descending: true,
      page: 1,
      rowsPerPage: 5,
      sortBy: 'id',
      totalItems: 0,
      rowsPerPageItems: [5]
    },
    loading: true
  },
  mutations: {
    setPagination (state, paginationData) {
      state.paginationData = paginationData
    },
    setCoversLate (state, covers) {
      state.covers = covers
    },
    setCoversLateTotalItems (state, totalItems) {
      state.paginationData.totalItems = totalItems
    },
    changeLoadingState (state, loading) {
      state.loading = loading
    },
    setCoversCompanies (state, { companies }) {
      state.covers.forEach(function (cover) {
        cover.seller = companies.find(function (company) {
          return company.id === cover.sellerId
        })

        cover.buyer = companies.find(function (company) {
          return company.id === cover.buyerId
        })
      })
    }
  },
  actions: {
    getCoversLate (context, filters) {
      let companyId = !!filters ? filters.companyId : undefined
      let coverId = !!filters ? filters.coverId : undefined
      let to = dayjs().format('MM/DD/YYYY')

      return coverApi.fetchCoversbyStatusPerPage(context.state.paginationData.page, context.state.paginationData.rowsPerPage, null, 'claimableat', to, to, 'dueat', 'asc', companyId, coverId).then((result) => {
        if (result) {
          let emptyCompany = {
            id: '',
            name: '',
            identifierType: '',
            identifierValue: ''
          }
          let covers = result.items.map((item) => {
            return {
              id: item.id,
              sellerId: item.sellerId,
              buyerId: item.buyerId,
              dueAt: item.invoice.dueAt,
              amount: item.invoice.amount + ' ' + item.invoice.currency.toUpperCase(),
              currency: item.invoice.currency.toUpperCase(),
              number: item.invoice.number,
              coverPrice: item.coverage.coverPrice !== undefined ? item.coverage.coverPrice + ' ' + item.coverage.currency.toUpperCase() : '',
              islate: dayjs().startOf('day').isAfter(dayjs(item.claimLimitAt).add(-6, 'days')),
              daysLate: dayjs(new Date()).diff(dayjs(item.invoice.dueAt).add(1, 'days'), 'days'),
              claimLimitAt: item.claimLimitAt,
              canbeclaimed: true,
              seller: emptyCompany,
              buyer: emptyCompany
            }
          })
          let totalItems = result.totalCount
          context.commit('setCoversLate', covers)
          context.commit('setCoversLateTotalItems', totalItems)
          store.dispatch('listcovertabs/setCoversLateCount', totalItems)
          if (totalItems > 0) {
            let sellerIds = covers.map((item) => { return item.sellerId })
            let buyerIds = covers.map((item) => { return item.buyerId })
            let companyIds = [...new Set(sellerIds.concat(buyerIds))]
            context.dispatch('getCoverCompanies', companyIds).then(() => {
              context.commit('changeLoadingState', false)
            })
          } else {
            context.commit('changeLoadingState', false)
          }
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    getCoverCompanies (context, companieIds) {
      return coverApi.fetchMappedCompaniesFromId(companieIds).then((companies) => {
        context.commit('setCoversCompanies', { companies })
      }).catch((err) => {
        console.log(err)
      })
    },
    setPagination (context, paginationData) {
      context.commit('setPagination', paginationData)
    },
    setCoversCompanies (context, companies) {
      context.commit('setCoversCompanies', { companies })
    },
    startLoadCovers (context) {
      context.commit('changeLoadingState', true)
    },
    getEmptyCovers (context) {
      context.commit('setCoversLate', [])
      context.commit('setCoversLateTotalItems', 0)
      context.commit('changeLoadingState', false)
    }
  }
}
